import { useState } from "react";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Field } from "@/components/common";

const PRESETS = [[30, 20], [40, 25], [50, 30], [60, 40], [100, 50]];
const FIELDS = [["name", "Nome"], ["price", "Preço"], ["barcode", "Código de barras"], ["internal_code", "Código interno"], ["unit", "Unidade"], ["expiry", "Validade"], ["store", "Nome da loja"]];

export function LabelConfig({ cfg, setCfg, onSave, saving }) {
  const isPreset = PRESETS.some(([w, h]) => w === cfg.width && h === cfg.height);
  const [custom, setCustom] = useState(!isPreset);
  const onSize = (v) => {
    if (v === "custom") return setCustom(true);
    setCustom(false);
    const [w, h] = v.split("x").map(Number);
    setCfg({ ...cfg, width: w, height: h });
  };
  const toggle = (k) => setCfg({ ...cfg, fields: cfg.fields.includes(k) ? cfg.fields.filter((x) => x !== k) : [...cfg.fields, k] });
  const dim = (k) => ({ type: "number", min: k === "width" ? 15 : 10, max: 150, value: cfg[k], onChange: (e) => setCfg({ ...cfg, [k]: Number(e.target.value) || 0 }), className: "w-24" });
  return (
    <div className="space-y-3 rounded-lg border p-3" data-testid="label-config">
      <div className="flex flex-wrap items-end gap-3">
        <Field label="Tamanho">
          <select value={custom ? "custom" : `${cfg.width}x${cfg.height}`} onChange={(e) => onSize(e.target.value)} className="h-10 rounded-md border bg-transparent px-2 text-sm" data-testid="label-size-select">
            {PRESETS.map(([w, h]) => <option key={`${w}x${h}`} value={`${w}x${h}`}>{w} x {h} mm</option>)}
            <option value="custom">Medida personalizada</option>
          </select>
        </Field>
        {custom && <Field label="Largura (mm)"><Input {...dim("width")} data-testid="label-width-input" /></Field>}
        {custom && <Field label="Altura (mm)"><Input {...dim("height")} data-testid="label-height-input" /></Field>}
        <Button type="button" variant="outline" size="sm" onClick={onSave} disabled={saving} className="ml-auto" data-testid="label-save-default-btn"><Save className="mr-1 h-4 w-4" />Salvar como padrão da loja</Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {FIELDS.map(([k, l]) => (
          <label key={k} className="flex cursor-pointer items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition-colors hover:bg-accent">
            <Checkbox checked={cfg.fields.includes(k)} onCheckedChange={() => toggle(k)} data-testid={`label-field-${k}`} />{l}
          </label>
        ))}
      </div>
    </div>
  );
}
